import styled from 'styled-components';

export const SiteFooterSection = styled.div`
  background: ${props => props.theme.colors.b.dgr};

  > section {
    ${props => props.theme.layout.sectionInner}
  }

  .nav {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 24px 0;
    border-bottom: 1px solid ${props => props.theme.colors.b.lg};

    .colored {
      a {
        color: ${props => props.theme.colors.b.bk};
      }
    }
  }

  select {
    padding: 10px 10px;
    border: 1px solid ${props => props.theme.colors.b.lg};
    background: ${props => props.theme.colors.b.dgr};
    color: ${props => props.theme.colors.b.wh};
  }

  .info {
    padding: 32px 0;

    > section {
      padding-bottom: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    p {
      font-size: 12px;
      color: ${props => props.theme.colors.b.wh};
      line-height: 1.7;
    }
  }

  .floating-banner {
    position: fixed;
    bottom: 300px;
    right: 50%;
    transform: translate(750px, 0);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    > a, > button {
      display: block;
      border-radius: 200px;
      overflow: hidden;
      width: auto;
      padding: 0;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);

      img {
        width: 136px;
        height: auto;
        vertical-align: middle;
      }
    }

    @media (max-width: ${props => props.theme.breakpoints.sm}) {
      display: none;
    }
  }

  .floating-banner-mobile {
    position: fixed;
    top: 60px;
    right: 5px;
    display: none;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    > a, > button {
      img {
        width: 60px;
        height: auto;
        vertical-align: middle;
      }
    }

    @media (max-width: ${props => props.theme.breakpoints.sm}) {
      display: flex;
    }
  }

  .footer-social-banner {
    width: 30px;
    margin: 30px auto 0;

    a {
      font-size: 22px;
      display: inline-block;
      padding: 8px 0;
      i {
        color: #999;
      }
    } 
  }

  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    padding: 0 4%;

    .nav {
      flex-direction: column;
      align-items: start;

      select {
        margin: 12px 0 0 0;
      }
    }

    .info {
      > section {
        flex-direction: column;
        align-items: start;
      }
    }
  }
`;
